import { useLocation, useOutlet } from "react-router-dom";
import { Rail } from "./Rail";
import { BarreMobile } from "./BarreMobile";
import { MicroButton } from "./MicroButton";
import { RAIL } from "./nav";
import { PanneauAssistant } from "@/components/assistant/PanneauAssistant";
import { ApercuBandeau } from "@/components/theme/ApercuBandeau";
import { Barre } from "@/components/messagerie/Wa";

const PLEIN = ["/", "/pipeline"];
const TITRES = { "/focus": "Mode focus", "/fiches-prospection": "Fichiers de prospection", "/contacts": "Contact", "/agenda": "Agenda", "/devis": "Devis", "/mur": "Mur d'équipe", "/visio": "Appel interne" };
const titreDe = (path) => {
  if (path.startsWith("/parametres")) return "Paramètres";
  if (path.startsWith("/fiches/")) return "Fiche";
  const t = Object.keys(TITRES).find((k) => path.startsWith(k));
  if (t && !RAIL.some((x) => x !== "sep" && x.path === t)) return TITRES[t];
  const e = RAIL.filter((x) => x !== "sep" && x.path !== "/").find((x) => path.startsWith(x.path));
  return e?.label || "Airthermo";
};

export const ShellMessagerie = () => {
  const { pathname } = useLocation();
  const outlet = useOutlet();
  const plein = PLEIN.includes(pathname);
  return (
    <div className="wa-fond" data-testid="wa-shell">
      <div className="wa-bandeau" aria-hidden="true" />
      <div className="wa-fenetre">
        <Rail />
        <main className="wa-main">
          <ApercuBandeau />
          {plein ? outlet : (
            <>
              <Barre titre={titreDe(pathname)} testId="wa-page-bar" />
              <div className="wa-defil">{outlet}</div>
            </>
          )}
        </main>
      </div>
      <div className="fixed z-40 at-halo" data-testid="assistant-fab"><MicroButton fab testId="assistant-fab-button" /></div>
      <BarreMobile />
      <PanneauAssistant />
    </div>
  );
};
